<template>
  <div >
    <Header
        @onRefreshClick="onRefresh"
        :leftArrow="true"
        :leftText="''"
        @leftClick="onClickLeft"
        :rightIcons="true"
    >
    </Header>
    <div style="display:flex;justify-content: center;">
      <van-form
          style="width: 100%; max-width: 500px; margin-top: 30px"
          ref="form"
      >
        <van-cell-group class="user-form-item" inset>
          <van-field
              v-for="(patient, index) in patientList" :key="index"
              is-link
              readonly
              :label="patient.name"
              @click="goChooseWaitBackground(patient.patient_id)"
          >
          </van-field>
        </van-cell-group>
      </van-form>

    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import 'vant/es/toast/style';

import { GetPatientList } from "@/services/patient";

export default {
  data() {
    return {
      patientList:[],
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.initPatientList();
  },
  created() {
  },
  methods: {
    goChooseWaitBackground(patient_id) {
      this.$router.push({
        path: "/waitBackground",
        query: {
          patient_id: patient_id,
        },
      });
    },
    async initPatientList() {
      let ret = await GetPatientList();
      if(ret.data.code >=0 && ret.data.data){
        this.patientList = ret.data.data;
      }
    },
    onClickLeft() {
      history.back();
    },
  },
  watch: {},
};
</script>

<style scoped>

</style>
